import React from 'react';
import firebase from 'firebase/compat/app';
// import { SubscribeButton } from '../SubscribeButton/SubscribeButton';

export class ScreenShareModal extends React.Component<{
  closeModal: () => void;
  startScreenShare: (useMediaSoup: boolean) => void;
  isSubscriber: boolean;
  user: firebase.User | undefined;
  beta?: boolean;
}> {
  render() {
    const { closeModal } = this.props;
    // const subscribeButton = !this.props.isSubscriber ? (
    //   <SubscribeButton user={this.props.user} />
    // ) : null;
    return (
      <dialog
        open={true}
        onClose={closeModal}
        className={`fixed inset-0 size-full z-[9999] bg-black/50 grid place-items-center`}
      >
        <div className="gradient-modal p-4 rounded-lg max-w-xl w-full relative">
          <div className="relative text-center">
            <span className="text-gradient-blue text-center text-2xl">
              Share Your Screen
            </span>
            <button
              onClick={() => {
                this.props.closeModal();
              }}
              className="text-white text-2xl absolute top-0 right-0"
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
          <ul>
            <li className="text-white text-[18px] my-4">
              To share audio, the "Share audio" checkbox needs to be checked in
              the screen selection dialog.
            </li>
            <li className="text-white text-[18px] my-4">
              Audio sharing is only supported if sharing your entire screen or a
              browser tab, not an application.
            </li>
          </ul>
          <button
            className="gradient-btn text-black p-3 text-[18px] font-semibold w-full rounded-xl duration-200 hover:opacity-70"
            onClick={() => {
              this.props.startScreenShare(false);
              this.props.closeModal();
            }}
          >
            Start Screen Sharing
          </button>

          {/* <Modal.Content image>
          <Modal.Description>
            <div>You're about to share your screen.</div>
            <ul>
              <li>To share audio, the "Share audio" checkbox needs to be checked in the screen selection dialog.</li>
              <li>
                Audio sharing is only supported if sharing your entire screen or a browser tab, not an application.
              </li>
            </ul>
            <Table definition unstackable striped celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell />
                  <Table.HeaderCell>WatchParty Free</Table.HeaderCell>
                  <Table.HeaderCell>WatchParty Plus</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row>
                  <Table.Cell>Method</Table.Cell>
                  <Table.Cell>
                    Stream your video to each viewer individually.
                  </Table.Cell>
                  <Table.Cell>
                    Our relay server streams to viewers for you.
                    <br />
                    Higher quality and lower bandwidth usage.
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Latency</Table.Cell>
                  <Table.Cell>{`< 1s`}</Table.Cell>
                  <Table.Cell>{`< 1s`}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Recommended Max Viewers</Table.Cell>
                  <Table.Cell>5</Table.Cell>
                  <Table.Cell>20</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Recommended Upload Speed</Table.Cell>
                  <Table.Cell>5 Mbps per viewer</Table.Cell>
                  <Table.Cell>5 Mbps</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell></Table.Cell>
                  <Table.Cell>
                    <Button
                      onClick={() => {
                        this.props.startScreenShare(false);
                        this.props.closeModal();
                      }}
                    >
                      Start Screenshare
                    </Button>
                  </Table.Cell>
                  <Table.Cell>
                    <Button
                      color="orange"
                      onClick={() => {
                        this.props.startScreenShare(true);
                        this.props.closeModal();
                      }}
                    >
                      Start Screenshare w/Relay
                    </Button>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content> */}
        </div>
      </dialog>
    );
  }
}
